export default __webpack_public_path__ + "static/media/10_papugi_m.a076f5a0.webp";